export const scale = {
  hover: 1,
  tap: 0.9
};
